module.exports = __webpack_public_path__ + "static/img/7.4ed69d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/7.png
// module id = y+5I
// module chunks = 0